
interface Props {
  error: Error;
  appName: string;
  onReset?: () => void;
}

export function MiniAppErrorFallback({ error, appName, onReset }: Props) {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center p-6">
      <div className="text-red-500 text-lg font-semibold mb-2">
        {appName} crashed
      </div>
      <p className="text-gray-500 text-sm mb-4 max-w-md">
        {error.message}
      </p>
      {onReset && (
        <button
          onClick={onReset}
          className="px-4 py-2 text-sm font-medium text-white bg-nightshade-600 rounded-lg hover:bg-nightshade-700 transition-colors"
        >
          Try again
        </button>
      )}
    </div>
  );
}
